<template>
  <div class="head-nav" :class="{'flex-nav': flex }">
    <div class="inner-container" :class="{ 'has-title': title}">
    
        <div class="side">
          <slot name="left">
            <Icon-button-fake/>
          </slot>
        </div>

        <div class="title">
          <div class="overflow" v-if="title">{{ tranlatedTitle }}</div>
          
          <catch-link v-if="!title" :href="computeSchoolUrl" target="_blank"><img :src="computeImageSrc"></catch-link>
          
        </div>
       
        <div class="side">
          <slot name="right">
            <Icon-button-fake/>
          </slot>
        </div>
        
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import IconButtonFake from './buttons/IconButtonFake.vue'; // need this to center the headnav
import CatchLink from '../components/CatchLink.vue';

export default {
  name: 'head-nav',
  props:{
    title: {default:""},
    flex:{default:true}
  },
  data(){
    return {
      school:{},
    }
  },
  components: {
    IconButtonFake,
    CatchLink,
  },
  computed:{
     ...mapState(['appSettings','user_schools']),
      tranlatedTitle:function(){
      if(this.title.indexOf('language.')!==-1){
        return this.$t(this.title)
      }else{
        return this.title
      }
    },
    computeImageSrc(){
      
      if(this.title!=""){
        return "";
      }
      if(this.appSettings.school_app_logo){
        return this.appSettings.school_app_logo;
      }else{
        return "";
      }
    },
    computeSchoolUrl(){
      return this.appSettings.school_app_website
      
    }
  },
  methods:{
  },
  mounted:function(){
    this.school=this.user_schools.find(school => school.active === 1)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.head-nav{
  border-bottom:1px solid #CCCCCC;
}

.flex-nav{
  display:flex;
}

.inner-container{
  display:flex;
  width:100%;
  position:relative;
  padding:10px;
}


.title{
  flex:1;
  text-align:center;
  font-size:1.2em;
  color:#50C0DB;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding:0 5px;
}
.overflow{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.has-title{
  align-items:center;
  justify-content:center;
}

img{
  width: 60%;
  height: auto;
  min-width: 150px;
  max-width: 380px;
}
</style>
